import { defineStore } from 'pinia';
import { ref } from 'vue';

import type { Modal, ModalActionPayload } from '@/components/ModalManager/types';
import { getInitialAppState, type Toast } from '@/stores/types/app';

export const useAppStore = defineStore('app', () => {
  const initial = getInitialAppState();
  const toast = ref<Toast>(initial.toast);
  const modals = ref<Modal[]>(initial.modals);

  const showToast = (nextToast: Omit<Toast, 'isOpen'> & { isOpen?: boolean }): void => {
    toast.value = { ...nextToast, isOpen: true };
  };

  const hideToast = (): void => {
    toast.value = {} as Toast;
  };

  const openModal = (modalActionPayload: ModalActionPayload): void => {
    modals.value = modals.value.map((modal) =>
      modal.id === modalActionPayload.id
        ? { ...modal, isOpen: true, options: modalActionPayload.options }
        : modal,
    );
  };

  const closeModal = (modalActionPayload: ModalActionPayload): void => {
    modals.value = modals.value.map((modal) =>
      modal.id === modalActionPayload.id ? { ...modal, isOpen: false, options: undefined } : modal,
    );
  };

  return {
    toast,
    modals,
    showToast,
    hideToast,
    openModal,
    closeModal,
  };
});
